<div class="error-file-container">
  <p class="error-file-text alt-inter-regular alt-size-14">{{"OPORTUNITIES.bad-save-file" | translate}}<b>{{extensionFile}}</b></p>
  <p class="error-file-info alt-inter-regular alt-size-14">{{"OPORTUNITIES.upload-correct-file" | translate | slice:0:36 }} <b>{{correctExt}}</b> {{"OPORTUNITIES.upload-correct-file" | translate | slice:36 }}</p>
</div>
